export { S4XMastheadProvider, useS4XMastheadContext, } from './S4XMastheadProvider';
